import { Routes } from '@angular/router';
import { HelpDeskComponent } from './components/help-desk/help-desk.component';
import { TicketDetailsComponent } from './components/ticket-details/ticket-details.component';

/**
 * Application route table.
 *
 * Two pages: the ticket list and one ticket's conversation. The ticket id is
 * carried in the URL rather than in component state, so `/ticket/176` can be
 * refreshed, bookmarked or pasted to someone else and still open the right
 * ticket - the detail page loads what it needs from that id when it has not
 * been handed anything (see `TicketDetailsComponent`).
 *
 * Anything unrecognised falls back to the list rather than a blank screen.
 */
export const routes: Routes = [
    { path: '', component: HelpDeskComponent },
    { path: 'ticket/:ticketId', component: TicketDetailsComponent },
    { path: '**', redirectTo: '' }
];
